import { useState, useEffect } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  Stack,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  CircularProgress,
  Typography,
  Box,
} from "@mui/material";
import { createNewAccount } from "../../../services/Admin/AccountsAdminAndUsersApi";

const ROLE_OPTIONS = [
  { value: "admin", label: "admin" },
  { value: "support", label: "support" },
];

const AddAccountDialog = ({ open, onClose, onSuccess }) => {
  const [loading, setLoading] = useState(false);
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [role, setRole] = useState(ROLE_OPTIONS[0].value);
  const [error, setError] = useState("");

  useEffect(() => {
    if (open) {
      setName("");
      setEmail("");
      setPassword("");
      setRole(ROLE_OPTIONS[0].value);
      setError("");
      setLoading(false);
    }
  }, [open]);

  const handleSubmit = async () => {
    setError("");
    if (!name.trim() || !email.trim() || !password.trim()) {
      setError("يرجى ملء الاسم، البريد، وكلمة المرور");
      return;
    }
    const payload = {
      name: name.trim(),
      email: email.trim(),
      password: password,
      role,
      type: "admin",
    };
    setLoading(true);
    try {
      const res = await createNewAccount(payload);
      if (res?.success) {
        onSuccess?.();
      } else {
        setError(res?.message || "فشل إنشاء الحساب");
      }
    } catch (err) {
      setError(err?.message || "حدث خطأ أثناء الإنشاء");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>إضافة حساب جديد</DialogTitle>
      <DialogContent>
        <Stack spacing={2} sx={{ mt: 1 }}>
          <TextField label="الاسم" value={name} onChange={(e) => setName(e.target.value)} fullWidth />
          <TextField label="البريد الإلكتروني" value={email} onChange={(e) => setEmail(e.target.value)} fullWidth />
          <TextField label="كلمة المرور" type="password" value={password} onChange={(e) => setPassword(e.target.value)} fullWidth />
          <FormControl fullWidth size="small">
            <InputLabel>الدور</InputLabel>
            <Select value={role} label="الدور" onChange={(e) => setRole(e.target.value)}>
              {ROLE_OPTIONS.map((r) => (
                <MenuItem key={r.value} value={r.value}>{r.label}</MenuItem>
              ))}
            </Select>
          </FormControl>
          {error && <Typography color="error">{error}</Typography>}
        </Stack>
      </DialogContent>
      <DialogActions>
        <Box sx={{ flex: 1 }} />
        <Button onClick={onClose} disabled={loading}>إلغاء</Button>
        <Button variant="contained" onClick={handleSubmit} disabled={loading}>
          {loading ? <CircularProgress size={18} /> : "حفظ"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default AddAccountDialog;
